import { useCallback, useState } from 'react';

import { SubmitFunction } from 'components/BaseForm/types';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

export function useSubmitReferentielForm<ValueT, ResponseDtoT>(
  refreshDashboard: () => void,
  closeModal: () => void,
  callApi: (values: ValueT) => Promise<ResponseDtoT>,
): SubmitFunction<ValueT> {
  const [inProgress, setInProgress] = useState<boolean>(false);

  const submit = useCallback(
    (values: ValueT) => {
      setInProgress(true);
      return callApi(values)
        .then(closeModal)
        .then(refreshDashboard)
        .catch((error: Response) => {
          void backAlertMessage(error);
        })
        .finally(() => {
          setInProgress(false);
        });
    },
    [closeModal, refreshDashboard],
  );

  return {
    submit: submit,
    inProgress: inProgress,
  };
}
